import type { CommonResourceKey } from './common';
import { commonResources } from './common';
import type { LayoutResourceKey } from './layout';
import { layoutResources } from './layout';
import type { AccountResourceKey } from './account';
import { accountResources } from './account';

export const CNResources: Record<CNResourceKey, string> = {
  ...commonResources,
  ...layoutResources,
  ...accountResources,
};

type CNResourceKey = CommonResourceKey | LayoutResourceKey | AccountResourceKey;
